<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>项目收费</span>
            <div>
              <el-button type="primary" size="small" @click="_chooseServFees">选择费用</el-button>
            </div>
          </div>
          <el-table
            :data="finishHousekeepingPoolInfo.fees"
            style="width: 100%"
            border
            stripe>
            <el-table-column prop="typeName" label="费用大类" align="center"></el-table-column>
            <el-table-column prop="feeName" label="费用名称" align="center"></el-table-column>
            <el-table-column prop="price" label="收费金额" align="center"></el-table-column>
            <el-table-column label="实收金额" align="center">
              <template slot-scope="scope">
                <el-input 
                  v-if="scope.row.state == '1001'"
                  v-model="scope.row.payPrice" 
                  placeholder="请输入实际收入金额"
                  size="small"></el-input>
                <span v-else>{{scope.row.payPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column label="状态" align="center">
              <template slot-scope="scope">
                {{scope.row.state == '1001'?'未支付':'已支付'}}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="danger" size="mini" @click="_deleteFee(scope.$index)" v-if="scope.row.state == '1001'">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-row style="margin-top: 20px;">
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="flex justify-between">
            <span>工单结单</span>
          </div>
          <el-form label-width="100px">
            <el-form-item label="处理意见">
              <el-input
                type="textarea"
                :rows="3"
                placeholder="必填，请填写处理意见"
                v-model="finishHousekeepingPoolInfo.context">
              </el-input>
            </el-form-item>
            <el-form-item label="处理前图片">
              <upload-image
                ref="beforeRepairUpload"
                :callBackListener="'finishHousekeepingPoolInfo'"
                :callBackFunction="'notifyUploadBeforeReapirImage'">
              </upload-image>
            </el-form-item>
            <el-form-item label="处理后图片">
              <upload-image
                ref="afterRepairUpload"
                :callBackListener="'finishHousekeepingPoolInfo'"
                :callBackFunction="'notifyUploadAfterReapirImage'">
              </upload-image>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="_finishHousekeepingPoolInfo">提交</el-button>
              <el-button @click="_back" style="margin-left: 20px;">返回</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>

    <choose-housekeeping-serv-fee
      ref="chooseHousekeepingServFee"
      @chooseHousekeepingServFee="handleChooseHousekeepingServFee">
    </choose-housekeeping-serv-fee>
  </div>
</template>

<script>
import { getShopId } from '@/api/shop/shopApi'
import { queryHousekeepingServConfig, queryStoreOrderCartFee, housekeepingServPoolFinish } from '@/api/goods/finishHousekeepingPoolApi'
import UploadImage from '@/components/system/UploadImageUrl'
import ChooseHousekeepingServFee from '@/components/goods/chooseHousekeepingServFee/chooseHousekeepingServFee'

export default {
  components: {
    UploadImage,
    ChooseHousekeepingServFee
  },
  data() {
    return {
      finishHousekeepingPoolInfo: {
        poolId: '',
        servId: '',
        context: '',
        fees: [],
        beforeRepairPhotos: [],
        afterRepairPhotos: []
      },
      shopId: '',
      validateErrInfo: ''
    }
  },
  created() {
    this.shopId = getShopId()
    console.log(queryHousekeepingServConfig)
    this.finishHousekeepingPoolInfo.poolId = this.$route.query.poolId
    this.finishHousekeepingPoolInfo.servId = this.$route.query.servId
    this._loadPoolFees()
  },
  methods: {
    _chooseServFees() {
      this.$refs.chooseHousekeepingServFee.open({
        servId: this.finishHousekeepingPoolInfo.servId
      })
    },
    handleChooseHousekeepingServFee(data) {
      data.state = '1001'
      data.price = data.feePrice
      data.payPrice = data.feePrice
      this.finishHousekeepingPoolInfo.fees.push(data)
    },
    _finishHousekeepingPoolInfo() {
      if (!this.finishHousekeepingPoolValidate()) {
        this.$message.error(this.validateErrInfo)
        return
      }
      
      let _fees = this.finishHousekeepingPoolInfo.fees.filter(item => {
        return item.state == '1001' && !item.cartId
      })
      
      let _data = {
        shopId: this.shopId,
        poolId: this.finishHousekeepingPoolInfo.poolId,
        context: this.finishHousekeepingPoolInfo.context,
        fees: _fees
      }

      housekeepingServPoolFinish(_data)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(res.msg)
            this._back()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(err => {
          this.$message.error(err)
        })
    },
    _deleteFee(index) {
      this.finishHousekeepingPoolInfo.fees.splice(index, 1)
    },
    _loadPoolFees() {
      queryStoreOrderCartFee({
        page: 1,
        row: 50,
        poolId: this.finishHousekeepingPoolInfo.poolId,
        shopId: this.shopId
      }).then(res => {
        this.finishHousekeepingPoolInfo.fees = res.data
      }).catch(err => {
        console.error('请求失败:', err)
      })
    },
    _back() {
      this.$router.go(-1)
    },
    finishHousekeepingPoolValidate() {
      if (!this.finishHousekeepingPoolInfo.poolId) {
        this.validateErrInfo = '报修单不能为空'
        return false
      }
      if (!this.finishHousekeepingPoolInfo.context) {
        this.validateErrInfo = '处理意见不能为空'
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
.upload-image {
  margin-top: 10px;
}
</style>